import React, { Component } from 'react';

import Videos from '../data/videosjson';
import {} from './OpenSourceHome.css';

class OpenSourceHome extends Component {
    constructor(props) {
        super(props);
        document.title = "g-C3N4 Open Source";
        this.state = {
            loaded: false,
            videos: this.setVideos(Videos.videolist)
        };
        
        this.state = {
            loaded: true,
            videos: this.state.videos
        };
    
    }

    setVideos(videolist) {
        return (
            videolist.map(item =>
                <div className="Video-container" key={item.id}>
                    <div className="Video-header" >
                        <div className="News-header-text">{item.title}</div>
                    </div>
                    <div className="Video-detail">
                        <div className="Video-detail-frame">
                        <iframe className="Video-detail-iframe" title="{item.title}" src={'https://www.youtube.com/embed/' + item.embed} frameBorder="0" gesture="media" allowFullScreen></iframe>
                        </div>
                    </div>
                    <div className="Video-footer" >
                        <p className="News-footer-text">{item.postscript}</p>
                    </div>
                </div>
                )
            )
    }


    render() {
        if (this.state.loaded) {
            return (
                <div className="container">
                    <p className="title">Open Source </p>
                    <p className="subtitle">You can experiment with g-C3N4 yourself</p>
                    <p className="subtitle Red">If you do your own research, please take the greatest of care and be aware of all dangers.</p>
                    <p>There are many excellent instrictions about how to make your own g-C3N4 round the web and we keep a list of our favourites here. 
                        If you think we've missed one that should be included, please do let us know.</p>
                    {this.state.videos} 
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default OpenSourceHome;


// WEBPACK FOOTER //
// ./src/OpenSource/OpenSourceHome.js